<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path d="M21.533 6.858c.015.213.015.426.015.64A13.9 13.9 0 0 1 7.553 21.492 13.9 13.9 0 0 1 0 19.284a10.174 10.174 0 0 0 1.188.061 9.851 9.851 0 0 0 6.107-2.1 4.927 4.927 0 0 1-4.6-3.411 6.2 6.2 0 0 0 .929.076 5.2 5.2 0 0 0 1.294-.167A4.919 4.919 0 0 1 .975 8.918v-.061a4.954 4.954 0 0 0 2.223.624 4.926 4.926 0 0 1-1.523-6.583 13.981 13.981 0 0 0 10.142 5.147 5.553 5.553 0 0 1-.117-1.127 4.923 4.923 0 0 1 8.513-3.365 9.684 9.684 0 0 0 3.122-1.188 4.906 4.906 0 0 1-2.162 2.711A9.861 9.861 0 0 0 24 4.318a10.573 10.573 0 0 1-2.467 2.54z" />
  </g>
</template>
